/* RANI CUSTOM — Cart önerileri & son gezdiklerin (Yeni Ürünler tarzı kart) */
(function () {
  'use strict';

  var STORAGE_KEY = 'rani_recent_products';
  var MAX_RECENT = 20;

  function fmtMoney(cents) {
    var n = (cents || 0) / 100;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function discountPercent(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round(((compare - price) / compare) * 100);
  }

  function pickSku(p) {
    if (p.variants && p.variants[0]) {
      var v = p.variants[0];
      if (v.sku) return v.sku;
    }
    return p.sku || p.id || '';
  }

  function firstAvailableVariantId(p) {
    if (!p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available !== false) return p.variants[i].id;
    }
    return p.variants[0].id;
  }

  function buildCard(p) {
    // Wonder card.liquid yapısını taklit eder → ana sayfa Yeni Ürünler kartıyla bire bir aynı CSS
    // Tüm görselleri normalize et: string ya da {src} olabilir
    var allImages = [];
    if (Array.isArray(p.images)) {
      allImages = p.images.map(function (it) {
        return (typeof it === 'string') ? it : (it && it.src ? it.src : '');
      }).filter(Boolean);
    }
    var img = (p.featured_image && p.featured_image.src) || (typeof p.featured_image === 'string' ? p.featured_image : '') || allImages[0] || '';
    var img2 = allImages.length > 1 ? allImages[1] : '';
    var hasGallery = allImages.length > 1;
    var pct = discountPercent(p.price, p.compare_at_price);
    var variantId = firstAvailableVariantId(p);

    var html = '<color-swatch class="rani-rec__card">';
    html +=   '<div class="card__container">';
    html +=     '<div class="card__picture-container">';
    html +=       '<a href="' + escapeHtml(p.url) + '" class="card" tabindex="0">';
    html +=         '<picture class="card__picture">';
    if (img) {
      html +=         '<img class="card__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
    }
    if (img2) {
      html +=         '<img class="card__img card__img--hover" src="' + escapeHtml(img2) + '" alt="" loading="lazy" aria-hidden="true">';
    }
    // Mobil swipe gallery — ana sayfa card.liquid içinde rani-card-gallery snippet rendered ediyor
    if (hasGallery) {
      var galleryImgs = allImages.slice(0, 6);
      html +=         '<div class="rani-card-gallery" data-rani-gallery data-count="' + galleryImgs.length + '">';
      html +=           '<div class="rani-card-gallery__track" data-rani-gallery-track>';
      galleryImgs.forEach(function (src) {
        html +=           '<div class="rani-card-gallery__slide">';
        html +=             '<img class="rani-card-gallery__img" src="' + escapeHtml(src) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
        html +=           '</div>';
      });
      html +=           '</div>';
      html +=           '<div class="rani-card-gallery__dots" aria-hidden="true">';
      galleryImgs.forEach(function (_, i) {
        html +=           '<span class="rani-card-gallery__dot' + (i === 0 ? ' is-active' : '') + '" data-rani-gallery-dot="' + i + '"></span>';
      });
      html +=           '</div>';
      html +=         '</div>';
    }
    html +=         '</picture>';
    html +=       '</a>';
    html +=     '</div>';
    html +=     '<div class="card-information">';
    html +=       '<span class="card__subtitle rani-taksit-pill">Peşin Fiyatına 3 Taksit</span>';
    html +=       '<h3 class="card__title"><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></h3>';
    html +=       '<div class="card__price price__sale visible">';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      html +=       '<span><s class="price-item price-item--regular">' + escapeHtml(fmtMoney(p.compare_at_price)) + '</s></span>';
    }
    html +=         '<div class="price__sale__details-wrapper">';
    html +=           '<span class="price-item price-item--sale">' + escapeHtml(fmtMoney(p.price)) + '</span>';
    if (pct > 0) {
      html +=         '<span class="price-item--percent">%' + pct + ' İndirim</span>';
    }
    html +=         '</div>';
    html +=       '</div>';
    if (variantId) {
      html +=     '<div class="card__quick-add-container">';
      html +=       '<button type="button" class="hero__button hero__button--secondary wt-button--full-width" data-rani-rec-add="' + variantId + '">Sepete Ekle</button>';
      html +=     '</div>';
    }
    html +=     '</div>';
    html +=   '</div>';
    html += '</color-swatch>';
    return html;
  }

  function getRecent() {
    try {
      var s = localStorage.getItem(STORAGE_KEY);
      if (!s) return [];
      var arr = JSON.parse(s);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function fetchProductsByHandles(handles) {
    var promises = handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });
    return Promise.all(promises).then(function (results) {
      return results.filter(function (p) { return p && p.available !== false; });
    });
  }

  function loadRelated(pid, limit) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&intent=related&limit=' + (limit || 8);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var arr = (data && data.products) ? data.products : [];
        return arr.filter(function (p) { return p && p.available !== false; });
      })
      .catch(function () { return []; });
  }

  function loadRecentlyViewed(limit) {
    var handles = getRecent().slice(0, limit || 8);
    if (handles.length === 0) return Promise.resolve([]);
    return fetchProductsByHandles(handles);
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.classList.add('is-adding');
    btn.disabled = true;
    btn.textContent = 'Ekleniyor…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    })
    .then(function () {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = '✓ Eklendi';
      setTimeout(function () {
        window.location.reload();
      }, 600);
    })
    .catch(function () {
      btn.classList.remove('is-adding');
      btn.disabled = false;
      btn.textContent = original;
      alert('Ürün eklenemedi. Lütfen tekrar deneyin.');
    });
  }

  function bindAddButtons(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rani-rec-add]');
      if (!btn) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-rani-rec-add');
      addToCart(vid, btn);
    });
  }

  function setupSliderNav(section) {
    var rail = section.querySelector('[data-rani-rec-rail]');
    var prev = section.querySelector('[data-rani-rec-prev]');
    var next = section.querySelector('[data-rani-rec-next]');
    if (!rail || !prev || !next) return;

    function scrollByVisible(dir) {
      var card = rail.querySelector('.rani-rec__card');
      if (!card) return;
      var cardW = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '0') || 0;
      var visible = Math.max(1, Math.floor(rail.clientWidth / (cardW + gap)));
      var amount = (cardW + gap) * visible * dir;
      rail.scrollBy({ left: amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByVisible(-1); });
    next.addEventListener('click', function () { scrollByVisible(1); });

    function updateNav() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max || max <= 0;
    }
    rail.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    setTimeout(updateNav, 100);
  }

  function renderSection(section) {
    var mode = section.getAttribute('data-rani-rec-mode');
    var limit = parseInt(section.getAttribute('data-rani-rec-limit'), 10) || 8;
    var rail = section.querySelector('[data-rani-rec-rail]');
    if (!rail) return;

    // related: kartlar artık Liquid'de sunucu tarafında dolu geliyor
    // (sepetteki ürünlerin GERÇEK kategorilerinden) — sadece etkileşimi bağla
    if (mode === 'related') {
      if (rail.querySelector('.rani-rec__card')) {
        bindAddButtons(section);
        setupSliderNav(section);
      } else {
        section.style.display = 'none';
      }
      return;
    }

    var loader;
    if (mode === 'recently_viewed') {
      // Gezilen ürün yoksa section'ı tamamen gizle (genel ürün fallback yok)
      loader = loadRecentlyViewed(limit);
    } else {
      section.style.display = 'none';
      return;
    }

    loader.then(function (products) {
      if (!products || products.length === 0) {
        // Section liquid'de baştan display:none — zaten gizli, bir şey yapma
        section.style.display = 'none';
        return;
      }
      // Ürün bulundu, section'ı görünür yap
      section.style.display = '';
      var html = '';
      products.forEach(function (p) { html += buildCard(p); });
      rail.innerHTML = html;
      bindAddButtons(section);
      setupSliderNav(section);
    });
  }

  function init() {
    document.querySelectorAll('[data-rani-rec]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* PDP tracker — ürün sayfasında handle'ı localStorage'a kaydet */
(function () {
  'use strict';
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var handleMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
  if (!handleMatch) return;
  var handle = handleMatch[1];

  try {
    var key = 'rani_recent_products';
    var stored = localStorage.getItem(key);
    var arr = stored ? JSON.parse(stored) : [];
    if (!Array.isArray(arr)) arr = [];
    arr = arr.filter(function (h) { return h !== handle; });
    arr.unshift(handle);
    if (arr.length > 20) arr = arr.slice(0, 20);
    localStorage.setItem(key, JSON.stringify(arr));
  } catch (e) {}
})();
